import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    className: '',
};

export const educationSlice = createSlice({
    name: "education",
    initialState,
    reducers: {
        setClassName: (state, { payload }) => {
            state.className = payload;
            return state;
        }
    },
});

export const { setClassName } = educationSlice.actions;

export default educationSlice.reducer;
